
import { Sinister } from '../../shared/types/sinisters/sinisterInfo';
import { Component, Inject, Emit, Prop, Vue } from 'vue-property-decorator';
import NoteForm from '../../core/components/Notes/NoteForm.vue'
import { Note } from '../../shared/types/notes/notes'
import { ClaimsPort } from '../../core/api/ports';
import { InjectionKey } from '../../core/injection-keys';
import { EventBus, TypeEventBus } from '../../core/utils';
@Component({
  components: {
    NoteForm
  },
})
export default class SinisterNotes extends Vue {
  @Inject(InjectionKey.ClaimsApi) readonly claimsApi!: ClaimsPort;
  @Prop({ default: () => [] }) sinister!: Sinister
  /** Nota seleccionada (compartida con el mapa): la guarda el contenedor de la página. */
  @Prop({ default: null }) selectedNoteId!: number | null;
  notes: Note[] = [];

  noteText: string = ''
  noteImages: (File | string)[] = []

  isEditing = false
  editingIndex: number | null = null;

  created(){
    
  }

  fetchNotes(): Promise<Note[]> {
    return this.claimsApi.getSinisterNotes(this.sinister.id)
      .then(res => {
        this.seeNotesInMap(res.ranch_notes)
        return res.ranch_notes
      })
  }

  @Emit()
  seeNotesInMap(notes: Note[]){}

  addNote(note: Note) {
    let sinisterId:any = this.sinister.id;
    return this.claimsApi.postNote(sinisterId, note)
  }

  updateNote(note: Note) {
    return this.claimsApi.patchNote(note)
  }

  deleteNote(note: Note) {
    return this.claimsApi.deleteNote(note.id as number)
  }

  cancelEdit() {
    this.resetForm()
  }

  resetForm() {
    this.noteText = ''
    this.noteImages = []
    this.editingIndex = null
    this.isEditing = false
  }

  formatDate(date: Date) {
    return new Intl.DateTimeFormat('es-AR', {
      dateStyle: 'short',
      timeStyle: 'short'
    }).format(new Date(date))
  }
}
